export default function mainSort() {

    const main = document.querySelector('main');
    const mainSort = document.querySelector('.js-main-sort');

    if ( main && mainSort ) {

        main.classList.add('main-flex-column');
        let sections = main.querySelectorAll('section');
        let oldBanner = main.querySelector('.main-ad');

        sections.forEach((section, index) => {
            section.style.order = index;
        });

        console.log('test', );

        if ( oldBanner ) {
            //oldBanner.style.order = mainSort.dataset.nextOrder;

            if ( document.querySelectorAll('.main-banner').length == 1 ) {
                oldBanner.style.order = 4;
            }
            if ( document.querySelectorAll('.main-banner').length == 2 ) {
                oldBanner.style.order = 5;
            }

        }

    }

}